import { Button, Result, Space, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import Globais from "../../../components/Globais";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame } from "../utils";

interface Props {
  fluxo: FluxoResposta;
}

export function CadastroConcluido({ fluxo }: Props) {
  const navigate = useNavigate();

  return (
    <OnboardingFrame
      fluxo={fluxo}
      title="Tudo certo! Seu cadastro foi concluído 🎉"
    >
      <Result
        status="success"
        title="Que tal encontrar sua próxima cota?"
        subTitle={
          <div style={{ maxWidth: 600, margin: "0 auto" }}>
            <Typography.Paragraph>
              Explore as cotas disponíveis para venda na Multicotas e descubra oportunidades em diferentes destinos e empreendimentos.
            </Typography.Paragraph>
            <Typography.Paragraph>
              Não encontrou o que procura? <strong>Cadastre seu interesse</strong> e avisaremos quando surgirem novas oportunidades.
            </Typography.Paragraph>
          </div>
        }
        extra={
          <Space direction="vertical" size="middle">
            <Button
              type="primary"
              size="large"
              onClick={() => window.location.assign(Globais.DOMINIOANUNCIO)}
              style={{
                minWidth: 220,
                borderRadius: 999,
                background: "#003644",
              }}
            >
              Ver oportunidades
            </Button>
            <Button
              type="link"
              size="large"
              onClick={() => navigate("/cadastroCotas")}
            >
              Ir para minhas propriedades
            </Button>
          </Space>
        }
      />
    </OnboardingFrame>
  );
}
